import { render } from "./TextMulti.vue?vue&type=template&id=37b0a2bb"
import script from "./TextMulti.vue?vue&type=script&lang=js"
export * from "./TextMulti.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__